var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgIconLogout = function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M356.453 243.741l-54.781-38.621c-9.926-6.997-23.644.128-23.644 12.26v23.621H15c-8.284 0-15 6.716-15 15s6.716 15 15 15h263.028v23.62c0 12.212 13.791 19.203 23.643 12.26l54.781-38.62c8.464-5.965 8.457-18.547.001-24.52z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M278.406 22.407c-86.155 0-161.824 46.757-202.333 116.783-4.148 7.171-1.698 16.347 5.473 20.495 7.172 4.148 16.347 1.696 20.495-5.474 35.237-60.91 101.094-101.804 176.365-101.804C390.668 52.407 482 143.738 482 256.001s-91.332 203.594-203.594 203.594c-75.317 0-141.153-40.934-176.366-101.807-4.148-7.171-13.323-9.62-20.495-5.474-7.171 4.148-9.622 13.324-5.473 20.495 40.519 70.047 116.201 116.785 202.334 116.785C407.514 489.595 512 385.119 512 256.001c0-129.109-104.475-233.594-233.594-233.594z"
  })));
};

export default __webpack_public_path__ + "static/media/icon-logout.623a8c9b.svg";
export { SvgIconLogout as ReactComponent };